import { PecSwitch, PrivateRoute } from 'components/route'
import { useFlags } from 'config/useFlagsContext'
import { useRouteMatch } from 'react-router'
import { Redirect, Route } from 'react-router-dom'
import { CBOS_ACESSO_CC } from 'types/NivelCbo'
import Permissions from 'types/Permissions.generated'
import { CuidadosCompartilhadosRootView } from 'view/cuidados-compartilhados/CuidadosCompartilhadosRootView'
import { getTiposEstabelecimentoCuidadoCompartilhado } from 'view/cuidados-compartilhados/util-cuidadoCompartilhado'
import { GARANTIA_ACESSO_UNIDADE_SAUDE_PATH } from 'view/lista-espera/model-garantiaAcesso'

import { GarantiaAcessoRootView } from './GarantiaAcessoRootView'

export const GestaoFilasRootView = () => {
  const { PILOTO_VINCULACAO_CUIDADO_ENABLED, PILOTO_INTEGRACAO_REGULACAO_ENABLED } = useFlags()
  const match = useRouteMatch()

  return (
    <PecSwitch>
      {PILOTO_INTEGRACAO_REGULACAO_ENABLED && (
        <Redirect exact from={match.url} to={`${match.url}${GARANTIA_ACESSO_UNIDADE_SAUDE_PATH}`} />
      )}
      <PrivateRoute
        path={`${match.url}/cuidados-compartilhados`}
        component={CuidadosCompartilhadosRootView}
        tiposEstabelecimento={getTiposEstabelecimentoCuidadoCompartilhado(PILOTO_VINCULACAO_CUIDADO_ENABLED)}
        cbos={CBOS_ACESSO_CC}
        permission={Permissions.cuidadoCompartilhado}
      />
      <Route path={`${match.url}`} component={GarantiaAcessoRootView} />
    </PecSwitch>
  )
}
